import { createRouter, createWebHistory } from 'vue-router'
import Loader from '../views/Loader.vue'
import Office from '../views/Office.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Loader,
      meta: {
        title: 'Portfolio | Sobhan Izadi - Software Developer',
        metaTags: [
          {
            rel: 'canonical',
            href: 'https://sobhanizadi.com'
          },
          {
            name: 'title',
            content: 'Portfolio | Sobhan Izadi - Software Developer'
          },
          {
            name: 'description',
            content:
              "Découvrez le portfolio de Sobhan Izadi, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            name: 'keywords',
            content: 'portfolio, sobhan izadi, développeur web, full stack, sites web, applications web, applications mobiles, JS, PHP, SQL, ORM, frameworks, DevOps'
          },
          {
            name: 'author',
            content: 'Sobhan Izadi'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'theme-color',
            content: '#000000'
          },
          {
            name: 'mobile-web-app-capable',
            content: 'yes'
          },
          {
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          },
          {
            name: 'apple-mobile-web-app-title',
            content: 'Portfolio | Sobhan Izadi - Software Developer'
          },
          {
            name: 'application-name',
            content: 'Portfolio | Sobhan Izadi - Software Developer'
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:title',
            content: 'Portfolio | Sobhan Izadi - Software Developer'
          },
          {
            name: 'twitter:description',
            content:
              "Découvrez le portfolio de Sobhan Izadi, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            name: 'twitter:image',
            content: 'https://sobhanizadi.com/img/logo-portfolio-black.webp'
          },
          {
            name: 'twitter:image:alt',
            content: 'Logo Portfolio Sobhan Izadi'
          },
          {
            property: 'og:type',
            content: 'website'
          },
          {
            property: 'og:title',
            content: 'Portfolio | Sobhan Izadi - Software Developer'
          },
          {
            property: 'og:description',
            content:
              "Découvrez le portfolio de Sobhan Izadi, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            property: 'og:site_name',
            content: 'Portfolio | Sobhan Izadi - Software Developer'
          },
          {
            property: 'og:url',
            content: 'https://sobhanizadi.com'
          },
          {
            property: 'og:image',
            content: 'https://sobhanizadi.com/img/logo-portfolio-black.webp'
          },
          {
            property: 'og:image:alt',
            content: 'Logo Portfolio Sobhan Izadi'
          },
          {
            property: 'og:locale',
            content: 'fr_FR'
          },
          {
            property: 'og:locale:alternate',
            content: 'en_US'
          }
        ]
      }
    },
    {
      path: '/office',
      name: 'Office',
      component: Office,
      meta: {
        title: 'Office | Sobhan Izadi - Software Developer',
        metaTags: [
          {
            rel: 'canonical',
            href: 'https://sobhanizadi.com/office'
          },
          {
            name: 'title',
            content: 'Office | Sobhan Izadi - Software Developer'
          },
          {
            name: 'description',
            content:
              "Découvrez le bureau de Sobhan Izadi, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            name: 'keywords',
            content: 'bureau, sobhan izadi, développeur web, full stack, sites web, applications web, applications mobiles, JS, PHP, SQL, ORM, frameworks, DevOps'
          },
          {
            name: 'author',
            content: 'Sobhan Izadi'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'theme-color',
            content: '#000000'
          },
          {
            name: 'mobile-web-app-capable',
            content: 'yes'
          },
          {
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          },
          {
            name: 'apple-mobile-web-app-title',
            content: 'Office | Sobhan Izadi - Software Developer'
          },
          {
            name: 'application-name',
            content: 'Office | Sobhan Izadi - Software Developer'
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:title',
            content: 'Office | Sobhan Izadi - Software Developer'
          },
          {
            name: 'twitter:description',
            content:
              "Découvrez le bureau de Sobhan Izadi, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            name: 'twitter:image',
            content: 'https://sobhanizadi.com/img/logo-portfolio-black.webp'
          },
          {
            name: 'twitter:image:alt',
            content: 'Logo Portfolio Sobhan Izadi'
          },
          {
            name: 'og:type',
            content: 'website'
          },
          {
            name: 'og:title',
            content: 'Office | Sobhan Izadi - Software Developer'
          },
          {
            name: 'og:description',
            content:
              "Découvrez le bureau de Sobhan Izadi, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            name: 'og:site_name',
            content: 'Office | Sobhan Izadi - Software Developer'
          },
          {
            name: 'og:url',
            content: 'https://sobhanizadi.com/office'
          },
          {
            name: 'og:image',
            content: 'https://sobhanizadi.com/img/logo-portfolio-black.webp'
          },
          {
            name: 'og:image:alt',
            content: 'Logo Portfolio Sobhan Izadi'
          },
          {
            name: 'og:locale',
            content: 'fr_FR'
          },
          {
            name: 'og:locale:alternate',
            content: 'en_US'
          }
        ]
      }
    }
  ]
})

export default router
